import coupleImg1 from '../../images/couple/image-4.jpg'
import coupleImg2 from '../../images/couple/image-5.jpg'
import icon from '../../images/couple/love-birds.svg'


const CoupleSection2: React.FC = () => {

    return (
        <section className="wpo-couple-section-s2">
            <div className="container-fluid">
                <div className="couple-wrap">
                    <div className="row">
                        <div className="col col-lg-6 col-md-12 col-12">
                            <div className="couple-items wow fadeInLeftSlow" data-wow-duration="1200ms">
                                <div className="couple-text">
                                    <h2>Max Wilson</h2>
                                    <p>A heart full of love and a soul full of hope, I can't wait to begin this journey
                                        with
                                        you by my side.</p>
                                </div>
                                <div className="couple-image">
                                    <img src={coupleImg1} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col col-lg-6 col-md-12 col-12">
                            <div className="couple-items wow fadeInRightSlow" data-wow-duration="1200ms">
                                <div className="couple-text">
                                    <h2>Amanda Jenny</h2>
                                    <p>Today, I marry my best friend. With joy in my heart and love in my eyes, I’m
                                        ready
                                        for forever</p>
                                </div>
                                <div className="couple-image">
                                    <img src={coupleImg2} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="love-birds">
                    <img src={icon} alt=""/>
                </div>
            </div>
        </section>
    );
}

export default CoupleSection2;